
































































































import { Component, Vue } from 'vue-property-decorator';
import CatalogOrderStore from '@/store/CatalogOrderStore';

import AppStore from '@/store/App';
import VListSubItem from '@/components/core/VListSubItem.vue';

type Action = {
  text: string,
  to: any,
  icon?: string,
  badge?: number,
};

@Component({
  components: {
    VListSubItem,
  },
})
export default class CoreDrawer extends Vue {
  logo = require('@/assets/img/logo.svg');
  get links(): {
    to: string,
    icon: string,
    text: string,
    badge?: number,
    globalActions?: Action[],
    actions?: Action[],
    }[]
  { return [
      {
        to: '/',
        icon: this.mdi.viewDashboard,
        text: '経営状況'
      },
      {
        to: '/company',
        icon: this.mdi.domain,
        text: '会社一覧',
        globalActions: [
            {
                text: "請求管理",
                to: '/company/payments',
                icon: this.mdi.currencyJpy,
            },
            {
                text: "レンタル管理",
                to: '/company/rentals',
                icon: this.mdi.tablet,
            },
        ],
        actions: [
          {
            text: "ダッシュボード",
            to: 'dashboard'
          },
          {
            text: "店舗一覧",
            to: 'branch'
          },
          {
            text: "社員一覧",
            to: 'employee'
          },
        ],
      },
      {
        to: '/conversions',
        icon: this.mdi.note,
        text: 'コンバージョン一覧',
        badge: this.totalUnprocessedConversionCount,
        globalActions: [
          {
            text: "問い合わせ",
            to: '/conversions/contact',
            badge: 0,
          },
          {
            text: "資料請求",
            to: '/conversions/catalog_order',
            badge: this.unprocessedCatalogOrderCount,
          },
        ],
      },
      {
        to: '/promo',
        icon: this.mdi.earth,
        text: 'プロモサイト管理',
        globalActions: [
            {
                text: 'お知らせ',
                to: '/promo/news',
            },
            {
                text: '導入事例',
                to: '/promo/cases',
            }
        ]
      },
      {
        to: '/agency',
        icon: this.mdi.store,
        text: '代理店一覧'
      },
      {
        to: '/notifications',
        icon: this.mdi.bell,
        text: '通知'
      }
  ];
    }
  responsive = false;

  get color() { return AppStore.color; }
  get image() { return AppStore.image; }
  get inputValue() { return AppStore.drawer; }
  set inputValue( val: any ) { this.setDrawer(val); }

  setDrawer( val: any ) {
    AppStore.SET_DRAWER(val);
  }

  toggleDrawer() {
    AppStore.TOGGLE_DRAWER();
  }

  async mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)

    if(CatalogOrderStore.unprocessedCount == -1)
      await CatalogOrderStore.updateUnprocessedCount();
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  }

  onResponsiveInverted () {
    if (window.innerWidth < 991) {
      this.responsive = true
    } else {
      this.responsive = false
    }
  }

  /* Conversion */
    get totalUnprocessedConversionCount(): number {
        return this.unprocessedCatalogOrderCount;
    }

    get unprocessedCatalogOrderCount(): number {
        return CatalogOrderStore.unprocessedCount;
    }
}
